<template>
  <div>
    <b-jumbotron>
      <b-container>
        <h1 v-label-key="'MY_NETWORK'">My Network</h1>
      </b-container>
    </b-jumbotron>
    <b-container>
      <ReportList :level="auth.user.selectedAccess.roleLevel" />
    </b-container>
  </div>
</template>

<script>
import $auth from '@/services/auth';
import ReportList from '@/components/ReportList';

export default {
  components: {
    ReportList,
  },
  data() {
    return {
      auth: $auth,
    };
  },
  created() {
    // var userRestrictions = {};
    // $auth.user.selectedAccess.distributor_id && (userRestrictions["chains.distributor_id"] = $auth.user.selectedAccess.distributor_id);
    // $auth.user.selectedAccess.subdistributor_id && (userRestrictions["chains.subdistributor_id"] = $auth.user.selectedAccess.subdistributor_id);
    // $auth.user.selectedAccess.chain_id && (userRestrictions["chains.id"] = $auth.user.selectedAccess.chain_id);
    // $auth.user.selectedAccess.store_id && (userRestrictions["stores.id"] = $auth.user.selectedAccess.store_id);
    // this.userRestrictions = userRestrictions;
  },
};
</script>
